import type { StoreState } from '../../StoreState';
import { IEventAggregator } from '../EventAggregator';
import { CatalogAnalyticsListener } from './listeners/CatalogAnalyticsListener';
import { CheckoutAnalyticsListener } from './listeners/CheckoutAnalyticsListener';
import { ConfiguratorAnalyticsListener } from './listeners/ConfiguratorAnalyticsListener';
import { ProductFamilyAnalyticsListener } from './listeners/ProductFamilyAnalyticsListener';
import { RequestQuoteAnalyticsListener } from './listeners/RequestQuoteAnalyticsListener';
import { WebShopAnalyticsListener } from './listeners/WebShopAnalyticsListener';

/**
 * Wires every analytics listener to the event bus once, at app startup.
 * Listeners are dormant singletons — each reacts only when its domain events are published.
 * This list is the single place trackers are registered; it imports listeners, never page states.
 */
export function registerAnalyticsListeners(eventAggregator: IEventAggregator, getStore: () => StoreState): void {
  // Listeners self-subscribe to the bus in their constructors — construction is the side effect.
  // tslint:disable:no-unused-expression
  new CatalogAnalyticsListener(eventAggregator, getStore);
  new ProductFamilyAnalyticsListener(eventAggregator, getStore);
  new ConfiguratorAnalyticsListener(eventAggregator, getStore);
  new RequestQuoteAnalyticsListener(eventAggregator, getStore);
  new CheckoutAnalyticsListener(eventAggregator);
  new WebShopAnalyticsListener(eventAggregator);
  // tslint:enable:no-unused-expression
}
